var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReactiveDynamicForm',{attrs:{"schema":_vm.schema,"entity-id":_vm.entityId}})}
var staticRenderFns = []

export { render, staticRenderFns }